<template>
  <div class="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-2xl shadow-sm p-6 flex flex-col w-full max-w-full" id="dashboard-quick-actions-section">
    <h2 class="text-xl font-semibold text-gray-900 dark:text-white mb-4 text-center" id="dashboard-quick-actions-title">{{ t('dashboard.quickActions') }}</h2>
    <div class="flex flex-wrap w-full" id="dashboard-quick-actions-grid">
      <button @click="navigateTo('/aiChatAgents')" class="w-full sm:w-1/2 p-2" id="dashboard-quick-action-new-agent">
        <div class="w-full flex items-center justify-center p-4 bg-gray-50 dark:bg-gray-700 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors">
          <Icon icon="tabler:plus" width="24" class="text-blue-500" :class="isHebrew === true ? 'ml-4' : 'mr-4'" />
          <span class="text-gray-900 dark:text-white">{{ t('dashboard.newAgent') }}</span>
        </div>
      </button>
      <button @click="navigateTo('/users')" class="w-full sm:w-1/2 p-2" id="dashboard-quick-action-settings">
        <div class="w-full flex items-center justify-center p-4 bg-gray-50 dark:bg-gray-700 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors">
          <Icon icon="tabler:settings" width="24" class="text-purple-500" :class="isHebrew === true ? 'ml-4' : 'mr-4'" />
          <span class="text-gray-900 dark:text-white">{{ t('dashboard.settings') }}</span>
        </div>
      </button>
      <button @click="navigateTo('/reports')" class="w-full sm:w-1/2 p-2" id="dashboard-quick-action-analytics">
        <div class="w-full flex items-center justify-center p-4 bg-gray-50 dark:bg-gray-700 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors">
          <Icon icon="tabler:chart-bar" width="24" class="text-green-500" :class="isHebrew === true ? 'ml-4' : 'mr-4'" />
          <span class="text-gray-900 dark:text-white">{{ t('dashboard.analytics') }}</span>
        </div>
      </button>
      <button @click="navigateTo('/helpAgent')" class="w-full sm:w-1/2 p-2" id="dashboard-quick-action-help">
        <div class="w-full flex items-center justify-center p-4 bg-gray-50 dark:bg-gray-700 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors">
          <Icon icon="tabler:help-circle" width="24" class="text-yellow-500" :class="isHebrew === true ? 'ml-4' : 'mr-4'" />
          <span class="text-gray-900 dark:text-white">{{ t('dashboard.help') }}</span>
        </div>
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { Icon } from "@iconify/vue/dist/offline";
import { useI18n } from '@/i18n.js';

const router = useRouter();
const { t, currentLanguage } = useI18n();

const isHebrew = computed(() => currentLanguage.value === 'he');

function navigateTo(route) {
  router.push(route);
}
</script>








